'use strict';

import angular from 'angular';
import ListController from './list.controller';

export default angular.module('updateServerApp.dictionaries.list', [])
  .controller('DictionariesListController', ListController)
  .name;



// WEBPACK FOOTER //
// ./client/app/dictionaries/list/index.js